import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalToFraction',
})
export class DecimalToFractionPipe implements PipeTransform {
  /**
   * Greatest Common Divisor - Euclid's Algorithm
   * @link https://stackoverflow.com/questions/23575218/convert-decimal-number-to-fraction-in-javascript-or-closest-fraction
   */
  static gcd(a: number, b: number): number {
    if (b < 0.0000001) {
      return a;
    } // Since there is a limited precision we need to limit the value.

    return DecimalToFractionPipe.gcd(b, Math.floor(a % b)); // Discard any fractions due to limitations in precision.
  }

  static decToFrac(dec: number): string {
    const len = dec.toString().length - 2; // 0.34

    let denominator = Math.pow(10, len); // 100
    let numerator = dec * denominator; // 34

    const divisor = DecimalToFractionPipe.gcd(numerator, denominator);

    numerator /= divisor;
    denominator /= divisor;
    return Math.floor(numerator) + '/' + Math.floor(denominator);
  }

  transform(value: number): any {
    const wholeNum = Math.floor(value);
    const fractionalNum = value % 1;
    let fractionStr = '';
    if (wholeNum > 0) {
      fractionStr += wholeNum + ' ';
    }
    if (fractionalNum > 0) {
      fractionStr += DecimalToFractionPipe.decToFrac(fractionalNum);
    }
    return fractionStr;
  }
}
